import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, tap, map, take, exhaustMap } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { LoaderService } from "./loader.service";
import { ActionResult, OrganiserPaymentData } from "@model";
import { EnvironmentService } from "./environment.service";

@Injectable({ providedIn: 'root' })
export class OrganiserPaymentDataService {
  private static _organiserPaymentData = new BehaviorSubject<OrganiserPaymentData | undefined>(undefined);

  get organiserPaymentData(): BehaviorSubject<OrganiserPaymentData | undefined> {
    return OrganiserPaymentDataService._organiserPaymentData;
  }

  constructor(
    private http: HttpClient,
    private loaderService: LoaderService,
    private authService: AuthenticationService,
    private environmentService: EnvironmentService
  ) {}

  fetchOrganiserPaymentData(organiserId?: number, hideLoading?: boolean): Observable<OrganiserPaymentData | null> {
    if (!hideLoading) this.loaderService.startLoading();
    return this.http.post<ActionResult<OrganiserPaymentData>>(this.environmentService.getApiUrl() + "/api/organiser/paymentdata/fetch", organiserId).pipe(
      tap(() => { if (!hideLoading) this.loaderService.dismissLoading(); }),
      map(value => value?.result ?? null)
    );
  }

  updatePaymentData(paymentData: OrganiserPaymentData, onSuccess: () => void, onError: () => void): void {
    this.loaderService.startLoading();
    this.authService.jwtResponse.pipe(
      take(1),
      exhaustMap(() => this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + "/api/organiser/paymentdata/update", paymentData))
    ).pipe(
      tap(() => this.loaderService.dismissLoading())
    ).subscribe(actionResult => actionResult.resultCode !== -1 ? onSuccess() : onError());
  }
}
